import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "UserActivity"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 17.25H18.7342C18.4054 17.2423 18.1198 17.0217 18.0292 16.7055L15.6525 8.39249L14.2013 12.2625C14.0919 12.5552 13.8125 12.7494 13.5 12.75H10.5V11.25H12.9802L15.048 5.73674C15.1616 5.43354 15.4569 5.23743 15.7804 5.25039C16.1039 5.26334 16.3826 5.48243 16.4715 5.79374L18.8048 13.9627L20.289 9.51299C20.3908 9.2067 20.6772 9 21 8.99999H24V10.5H21.54L19.461 16.737C19.3594 17.0434 19.0728 17.2502 18.75 17.25ZM11.25 22.5H9.75V17.25C9.74876 16.0079 8.74213 15.0012 7.5 15H4.5C3.25787 15.0012 2.25124 16.0079 2.25 17.25V22.5H0.75V17.25C0.75248 15.18 2.42996 13.5025 4.5 13.5H7.5C9.57004 13.5025 11.2475 15.18 11.25 17.25V22.5ZM6 6C7.24264 6 8.25 7.00736 8.25 8.25C8.25 9.49264 7.24264 10.5 6 10.5C4.75736 10.5 3.75 9.49264 3.75 8.25C3.75 7.00736 4.75736 6 6 6ZM6 4.5C3.92893 4.5 2.25 6.17893 2.25 8.25C2.25 10.3211 3.92893 12 6 12C8.07107 12 9.75 10.3211 9.75 8.25C9.75 6.17893 8.07107 4.5 6 4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/UserActivity.vue"]]);
